export default __webpack_public_path__ + "static/media/purrps-logo.96aa926a.png";